import React from 'react'
import { ReactComponent as LogoSVG } from '../../../../assets/svg/brand-logo-packhelp-white.svg'

export const Logo = ({ className }: { className?: string }) => {
  return <LogoSVG className={className} />
}
